export { default as getMultipliers } from './getMultipliers';

export type {
  GetMultipliersFunction,
  GetMultipliersPayload,
  GetMultipliersRequestPayload,
  Multiplier,
} from './getMultipliers.type';
